import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import FlexContainer from "../components/flex-container.js";
import SidebarLeft from "../components/sidebar-left.js";
import SidebarRight from "../components/sidebar-right.js";
import Container from '../components/container.js'
import ImageFooter from '../components/image-footer-une-ville-fabulee.js'
import SvgHamburger from "../../images/hamburger.svg"

const SecondPage = () => (
    <div>
    <FlexContainer>
        <Helmet bodyAttributes={{class: 'hamburger'}}/>
        <SidebarLeft></SidebarLeft>
        <Container>
            <SvgHamburger/>
            <h1>Une ville fabulée</h1>
            <p>En 1616, huit ans après avoir établi à Québec un comptoir de fourrures, Samuel de Champlain écrit au roi pour lui demander de fonder, dans les basses terres de la ville, une véritable colonie: Ludovica. Inspiré du modèle communal, l'établissement prévu pour la Pointe-aux-Lièvres (actuelle basse-ville) serait non seulement une halte pour les commerçants, mais une véritable capitale digne de Saint-Denis (Paris). Au cœur de la Nouvelle-France, dans l'enclave d'une vallée d'abondance, Ludovica serait le lieu d'un immense temple dédié au Rédempteur, un sanctuaire digne des plus beaux temples d'Orient: un siège de la foi dans le Nouveau Monde.</p>
            <p>Tout croyant qu'il était en quelque chose de plus grand que lui-même (et à cette époque les Européens appelaient cette chose Dieu), Champlain avait la foi. Plus de quatre cents ans plus tard, cette foi en quelque chose de plus grand que soi-même s'est imposée comme la source d'un autre projet. Si Ludovica n'a jamais vu le jour, Ludovica verrait le jour. Rien de de religieux ou de systématique, mais quelque chose de bien enraciné qui mijote, même au frette. On a donc écrit et filmé pour rappeler à bon entendeur qu'en des temps parfois dépressionnistes, les vents de l'intérieur peuvent encore mener au large. Mieux vaut, quand même, savoir manier la rame.</p>
        </Container>
        <SidebarRight></SidebarRight>
   </FlexContainer>
   <ImageFooter/>
   </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/une-ville-fabulee.js